export const API_URL = {
  chargebee: "/ms/b2b-subscription/v1/vendor/chargebee/proxy",
};
